import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { FlatTreeControl } from '@angular/cdk/tree';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import * as cloneDeep from 'lodash/cloneDeep';
import { Subject } from 'rxjs';
import {
  FeatureItemFlatNode,
  FeatureItemNode,
  Hierarchy,
  SiteModel
} from 'src/app/models/index';
import { CommonService, SiteStepperService } from 'src/app/services/index';
import { AddNodeTreeConfigurationModalComponent } from '../add-node-tree-configuration-modal/add-node-tree-configuration-modal.component';

@Component({
  selector: 'app-generic-tree-view-configuration',
  templateUrl: './generic-tree-view-configuration.component.html',
  styleUrls: ['./generic-tree-view-configuration.component.scss']
})
export class GenericTreeViewConfigurationComponent
  extends Hierarchy
  implements OnInit, AfterViewInit, OnDestroy
{
  @Output() updateBackEvent = new EventEmitter<any>();
  @ViewChild('genericViewTree') genericViewTree;
  @Input() data: any;
  @Input() treeConfigSubject: Subject<any>;
  @Input() siteId: string;
  @Input() processAndLoads: any;
  // siteId: string;
  siteModel: SiteModel;
  selectedEntityName: string;
  selectedEntityRId: any;
  immediateChildNodes: any;
  immediateChildEntites: any;
  treeType = {
    STATIC_TREE: 'STATIC_TREE',
    LOAD_ON_TREE: 'LOAD_ON_TREE',
    INVERTER_TREE: 'INVERTER_TREE',
    GENERIC_TREE: 'GENERIC_TREE'
  };
  currentNode: {
    nodeData: any;
    metersId: any;
    nodeTitle: string;
    nodeType: string;
    loadId: string;
    meterId: string;
    loadRId: string;
    kwRating: any;
  } = Object.assign({});
  genericTreeData: any;
  nodeInfoModalMode: any;
  nodeInfoModalMode_newFirst = 1;
  nodeInfoModalMode_new = 2;
  nodeInfoModalMode_edit = 3;
  nodeInfoModalTitle = '';
  uploadedFile: any;
  dashboardNameInputEnabled = false;
  selectedTreeType: any;
  expandedNodeSet = new Set<string>();
  dragging = false;
  expandTimeout: any;
  expandDelay = 1000;
  randomId = 1;
  constructor(
    private siteStepperService: SiteStepperService,
    private cdRef: ChangeDetectorRef,
    private dialog: MatDialog,
    private commonService: CommonService
  ) {
    super();
  }

  ngOnInit() {
    this.treeConfigSubject.subscribe((event) => {
      if (!this.commonService.isNullOrUndefined(event)) {
        if (Array.isArray(event) && event.length > 0) {
          this.data = event;
          this.displayData();
        }
      }
    });
  }

  ngAfterViewInit() {
    this.cdRef.detectChanges();
  }

  ngOnDestroy() {
    this.treeConfigSubject.unsubscribe();
  }

  displayData() {
    this.dataSource.data = [];
    this.genericTreeData = this.data;

    this.dataSource.data = this.buildFileTree(
      this.genericTreeData[0],
      this.dataSource.data,
      null,
      true
    );
    this.genericViewTree.treeControl.collapseAll();
  }
  buildFileTree(
    obj: any,
    nodes: FeatureItemNode[],
    currentSelected: FeatureItemFlatNode,
    firstTime?: boolean
  ): FeatureItemNode[] {
    const node = new FeatureItemNode();
    node.title = obj.title;
    node.index = obj.index;
    // node.id = obj.id;
    node.id = this.randomId++;
    node.nodeType = obj.nodeType;
    node.hasAttachment = obj.hasAttachment;
    node.RId = obj.RId;
    node.meterId = obj.meterId;
    node.meterRId = obj.meterRId;
    node.processId = obj.processId;
    node.processRId = obj.processRId;
    node.loadId = obj.loadId;
    node.loadRId = obj.loadRId;
    node.parameters = obj.parameters;
    if (firstTime && this.commonService.isNullOrUndefined(node.nodes)) {
      node.nodes = [];
    }
    if (currentSelected != null && currentSelected.id === obj.id) {
      node.selected = true;
    }
    if (obj.nodes !== undefined && obj.nodes.length > 0) {
      node.nodes = [];
      for (let i = 0; i < obj.nodes.length; i++) {
        const element = obj.nodes[i];
        element.index = i;
        node.nodes = this.buildFileTree(element, node.nodes, currentSelected);
      }
    }
    return nodes.concat(node);
  }
  updateBackToParent(data) {
    this.updateBackEvent.next(data);
  }
  // CRUD
  newSubItem(scope, treeType) {
    this.currentNode = scope;
    this.dashboardNameInputEnabled = false;
    this.selectedTreeType = treeType;
    this.nodeInfoModalMode = this.nodeInfoModalMode_new;

    const dialogRef = this.dialog.open(AddNodeTreeConfigurationModalComponent, {
      width: '40%'
      // height: '62%'
    });
    dialogRef.componentInstance.siteId = this.siteId;
    dialogRef.componentInstance.nodeInfoModalTitle = 'Add New Node';
    dialogRef.componentInstance.selectedTreeType = treeType;
    dialogRef.componentInstance.uploadedFile = undefined;
    dialogRef.componentInstance.dashboardNameInputEnabled = true;
    dialogRef.componentInstance.nodeInfoModalMode = this.nodeInfoModalMode;
    dialogRef.componentInstance.nodeData = scope;
    dialogRef.componentInstance.processes = this.processAndLoads;
    dialogRef.afterClosed().subscribe((result) => {
      if (result.status === true) {
        this.currentNode = result.data.nodeData;
        // this.updateNode(scope, this.currentNode);
        scope = result.data.nodeData;
        const src = [];
        this.dataSource.data = this.buildFileTree(
          this.dataSource.data[0],
          src,
          null
        );

        this.genericTreeData = cloneDeep(this.dataSource.data);
        this.updateBackToParent({
          genericTreeData: this.genericTreeData,
          nodeData: null
        });
      }
    });
  }

  editNode(scope, treeType) {
    this.dashboardNameInputEnabled = false;
    this.currentNode = scope;
    this.selectedTreeType = treeType;
    this.nodeInfoModalMode = this.nodeInfoModalMode_edit;

    const dialogRef = this.dialog.open(AddNodeTreeConfigurationModalComponent, {
      width: '60%'
      // height: auto
    });
    dialogRef.componentInstance.siteId = this.siteId;
    dialogRef.componentInstance.nodeInfoModalTitle = 'Modify Node';
    dialogRef.componentInstance.selectedTreeType = treeType;
    dialogRef.componentInstance.uploadedFile = undefined;
    dialogRef.componentInstance.dashboardNameInputEnabled = true;
    dialogRef.componentInstance.nodeInfoModalMode = this.nodeInfoModalMode;
    dialogRef.componentInstance.nodeData = scope;
    dialogRef.componentInstance.processes = this.processAndLoads;
    dialogRef.afterClosed().subscribe((result) => {
      if (result.status === true) {
        this.currentNode = result.data.nodeData;

        // this.updateNode(t.dataSource.data, this.currentNode);
        this.updateNode(scope, this.currentNode);
        this.genericTreeData = null;
        this.genericTreeData = cloneDeep(this.dataSource.data);
        this.updateBackToParent({
          genericTreeData: this.genericTreeData,
          nodeData: null
        });
      }
    });
  }

  removeNodeItem(scope, treeType) {
    this.currentNode = scope;
    const parentNode = this.getParent(scope);
    if (parentNode === undefined || parentNode === null) {
      this.dataSource.data = [];
    } else if (parentNode.nodes !== undefined) {
      for (let i = 0; i < parentNode.nodes.length; i++) {
        const tempNode = <any>parentNode.nodes[i];
        if (tempNode.index !== undefined && tempNode.index === scope.index) {
          parentNode.nodes.splice(i, 1);
          break;
        }
      }
    }

    this.genericTreeData = cloneDeep(this.dataSource.data);
    this.dataSource.data = this.dataSource.data;
    this.updateBackToParent({
      genericTreeData: this.genericTreeData,
      nodeData: this.currentNode
    });
  }

  private getParent = (node: any) => {
    const currentLevel = this.treeControl.getLevel(node);
    if (currentLevel < 1) {
      return null;
    }
    const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;
    for (let i = startIndex; i >= 0; i--) {
      const currentNode = this.treeControl.dataNodes[i];

      if (this.treeControl.getLevel(currentNode) < currentLevel) {
        return currentNode;
      }
    }
  };
  // private updateNode = (data: any, nodeData: any) => {
  //   for (let i = 0; i < data.length; i++) {
  //     const node = data[i];
  //     if (node.index === nodeData.index) {
  //       Object.assign(node, nodeData);
  //       break;
  //     }

  //     if (node.nodes !== undefined && node.nodes !== null && node.nodes.length > 0) {
  //       this.updateNode(node.nodes, nodeData);
  //     }
  //   }
  // }
  private updateNode = (oldnode: any, newnode: any) => {
    const parentNode = this.getParent(oldnode);
    if (parentNode === null) {
      Object.assign(oldnode, newnode);
    } else {
      for (let i = 0; i < parentNode.nodes.length; i++) {
        const tempNode = <any>parentNode.nodes[i];
        if (tempNode.index !== undefined && tempNode.index === oldnode.index) {
          Object.assign(tempNode, newnode);
          break;
        }
      }
    }
  };
  /**
   * This constructs an array of nodes that matches the DOM,
   * and calls rememberExpandedTreeNodes to persist expand state
   */
  visibleNodes(): FeatureItemNode[] {
    this.rememberExpandedTreeNodes(this.treeControl, this.expandedNodeSet);
    const result = [];

    function addExpandedChildren(node: FeatureItemNode, expanded: Set<string>) {
      result.push(node);
      if (expanded.has(node.id.toString())) {
        node.nodes.forEach((child) => addExpandedChildren(child, expanded));
      }
    }
    this.dataSource.data.forEach((node) => {
      addExpandedChildren(node, this.expandedNodeSet);
    });
    return result;
  }
  /**
   * Handle the drop - here we rearrange the data based on the drop event,
   * then rebuild the tree.
   * */
  drop(event: CdkDragDrop<string[]>) {
    // console.log('origin/destination', event.previousIndex, event.currentIndex);
    // ignore drops outside of the tree
    if (!event.isPointerOverContainer) {
      return;
    }

    // construct a list of visible nodes, this will match the DOM.
    // the cdkDragDrop event.currentIndex jives with visible nodes.
    // it calls rememberExpandedTreeNodes to persist expand state
    const visibleNodes = this.visibleNodes();

    // deep clone the data source so we can mutate it
    const changedData = JSON.parse(JSON.stringify(this.dataSource.data));

    // recursive find function to find siblings of node
    function findNodeSiblings(arr: Array<any>, id: string): Array<any> {
      let result, subResult;
      arr.forEach((item) => {
        if (item.id.toString() === id) {
          result = arr;
        } else if (item.nodes) {
          subResult = findNodeSiblings(item.nodes, id);
          if (subResult) {
            result = subResult;
          }
        }
      });
      return result;
    }

    // remove the node from its old place
    const node = event.item.data;
    const siblings = findNodeSiblings(changedData, node.id.toString());
    const siblingIndex = siblings.findIndex((n) => n.id === node.id);
    const nodeToInsert: FeatureItemNode = siblings.splice(siblingIndex, 1)[0];

    // determine where to insert the node
    const nodeAtDest = visibleNodes[event.currentIndex];
    if (nodeAtDest.id === nodeToInsert.id) {
      return;
    }

    // determine drop index relative to destination array
    let relativeIndex = event.currentIndex; // default if no parent
    const nodeAtDestFlatNode = this.treeControl.dataNodes.find(
      (n) => nodeAtDest.id === n.id
    );
    const parent = this.getParentNode(nodeAtDestFlatNode);
    if (parent) {
      const parentIndex = visibleNodes.findIndex((n) => n.id === parent.id) + 1;
      relativeIndex = event.currentIndex - parentIndex;
    }
    // insert node
    const newSiblings = findNodeSiblings(
      changedData[0].nodes,
      nodeAtDest.id.toString()
    );
    if (!newSiblings) {
      return;
    }
    newSiblings.splice(relativeIndex, 0, nodeToInsert);
    // rebuild tree with mutated data
    this.rebuildTreeForData(changedData);
  }
  rebuildTreeForData(data: any) {
    this.rememberExpandedTreeNodes(this.treeControl, this.expandedNodeSet);
    this.dataSource.data = data;
    this.forgetMissingExpandedNodes(this.treeControl, this.expandedNodeSet);
    this.expandNodesById(
      this.treeControl.dataNodes,
      Array.from(this.expandedNodeSet)
    );
    this.genericTreeData = cloneDeep(this.dataSource.data);
    this.updateBackToParent({
      genericTreeData: this.genericTreeData,
      nodeData: null
    });
  }
  private forgetMissingExpandedNodes(
    treeControl: FlatTreeControl<FeatureItemFlatNode>,
    expandedNodeSet: Set<string>
  ) {
    if (treeControl.dataNodes) {
      expandedNodeSet.forEach((nodeId) => {
        // maintain expanded node state
        if (!treeControl.dataNodes.find((n) => n.id.toString() === nodeId)) {
          // if the tree doesn't have the previous node, remove it from the expanded list
          expandedNodeSet.delete(nodeId);
        }
      });
    }
  }

  private expandNodesById(flatNodes: FeatureItemFlatNode[], ids: string[]) {
    if (!flatNodes || flatNodes.length === 0) {
      return;
    }
    const idSet = new Set(ids);
    return flatNodes.forEach((node) => {
      if (idSet.has(node.id.toString())) {
        this.treeControl.expand(node);
        let parent = this.getParentNode(node);
        while (parent) {
          this.treeControl.expand(parent);
          parent = this.getParentNode(parent);
        }
      }
    });
  }
  private getParentNode(node: FeatureItemFlatNode): FeatureItemFlatNode | null {
    const currentLevel = node.level;
    if (currentLevel < 1) {
      return null;
    }
    const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;
    for (let i = startIndex; i >= 0; i--) {
      const currentNode = this.treeControl.dataNodes[i];
      if (currentNode.level < currentLevel) {
        return currentNode;
      }
    }
    return null;
  }
  /**
   * Experimental - opening tree nodes as you drag over them
   */
  dragStart() {
    this.dragging = true;
  }
  dragEnd() {
    this.dragging = false;
  }
  dragHover(node: any) {
    if (this.dragging) {
      clearTimeout(this.expandTimeout);
      this.expandTimeout = setTimeout(() => {
        this.treeControl.expand(node);
      }, this.expandDelay);
    }
  }
  dragHoverEnd() {
    if (this.dragging) {
      clearTimeout(this.expandTimeout);
    }
  }
  private rememberExpandedTreeNodes(
    treeControl: FlatTreeControl<FeatureItemFlatNode>,
    expandedNodeSet: Set<string>
  ) {
    if (treeControl.dataNodes) {
      treeControl.dataNodes.forEach((node) => {
        if (treeControl.isExpandable(node) && treeControl.isExpanded(node)) {
          // capture latest expanded state
          expandedNodeSet.add(node.id.toString());
        }
      });
    }
  }
  public featureLeafItemSelectionToggle(node: FeatureItemFlatNode): void {}
}
